export const nodeVersions = [
  { value: '16', label: '16' },
  { value: '18', label: '18' },
  { value: '20', label: '20' },
  { value: '22', label: '22' },
  { value: 'lts', label: 'lts' },
  { value: 'latest', label: 'latest' },
]
